/**
 * Created by Denis Kuzin on 05 august 2024
 */

var LiveLineComponent = function (cell) {
    this.cell = cell;
};